import { orderXClient } from '@/service/client'
import {
  type CreatePositionGroupRequest,
  type DeletePositionGroupRequest,
  type GetPositionGroupsRequest,
  type GetPositionGroupsResponse,
  type GetPositionsViewRequest,
  type GetPositionsViewResponse,
  type PositionGroupMutationResponse,
  type ReorderPositionsViewRequest,
  ServerMessage,
  type SetPositionGroupOrderRequest,
  type UpdatePositionGroupRequest,
} from '@/types/generated/public_api'

export async function createPositionGroup(
  req: CreatePositionGroupRequest
): Promise<PositionGroupMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { createPositionGroup: req })
  return data.positionGroupMutationResponse!
}

export async function updatePositionGroup(
  req: UpdatePositionGroupRequest
): Promise<PositionGroupMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { updatePositionGroup: req })
  return data.positionGroupMutationResponse!
}

export async function deletePositionGroup(
  req: DeletePositionGroupRequest
): Promise<PositionGroupMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { deletePositionGroup: req })
  return data.positionGroupMutationResponse!
}

export async function getPositionGroups(
  req: GetPositionGroupsRequest
): Promise<GetPositionGroupsResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { getPositionGroups: req })
  return data.getPositionGroupsResponse!
}

export async function getPositionsView(
  req: GetPositionsViewRequest
): Promise<GetPositionsViewResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { getPositionsView: req })
  return data.getPositionsViewResponse!
}

// Persist the interleaved top-level order. Response reuses the
// getPositionsViewResponse tag (39) — a full rebuilt view in the new order.
export async function reorderPositionsView(
  req: ReorderPositionsViewRequest
): Promise<GetPositionsViewResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { reorderPositionsView: req })
  return data.getPositionsViewResponse!
}

// Persist a group's leg order. Response is an ack, not the rebuilt view —
// refetch the view afterward to reflect the new leg order.
export async function setPositionGroupOrder(
  req: SetPositionGroupOrderRequest
): Promise<PositionGroupMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { setPositionGroupOrder: req })
  return data.positionGroupMutationResponse!
}
